<template>
  <div>

    <div class="landing-el content-wrapper">

        <section class="landing-el hero is-landing is-large">

            <div class="landing-el hero-body">
                <div class="landing-el container has-text-centered">

                    <div class="landing-el columns">
                        <div class="landing-el column is-6 is-offset-3">
                            


                            <h1 ref="landingOQueE" class="landing-el has-text-dark title is-1">
                                Plataforma ProCal
                            </h1>

                            <h2 class="landing-el subtitle has-text-grey is-4">
                                <span class="landing-el has-text-dark">A análise de dados e a gestão da calibração dos seus instrumentos.</span>
                            </h2>

                            <figure class="landing-el">
                                <img src="../assets/img/phone.png" alt="" style="-webkit-mask-image: -webkit-gradient( linear, left top, left bottom, color-stop(0.00, rgba(0,0,0,1)), color-stop(0.35, rgba(0,0,0,1)), color-stop(0.50, rgba(0,0,0,0)), color-stop(0.4, rgba(0,0,0,0)));"/>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="landing-el bg-light">

            <div class="landing-el container section">


              <div class="landing-el content has-text-centered">
                  <p class="landing-el title is-3 subtitle">A plataforma IPT ProCal promove a transformação digital na entrega dos dados de calibração.</p>
              </div>


            </div>
        </section>
        <img class="" src="../assets/img/section_wave.png" alt="" style="width: 100%;height: 40px;"/>
        <section class="bg-white">
            <div ref="landingFuncionalidades" class="container section">
                <div class="columns is-vcentered">
                  <div class="column ">
                    <div class="content">
                      <p class="landing-el title is-3">Análise expandida</p>
                      <p class="landing-el subtitle has-text-grey is-size-4">Veja a análise dos dados de calibração em forma de gráficos de curva e tendência. Faça mudanças de parâmetros diretamente na plataforma.</p>
                      <p class="landing-el subtitle has-text-grey is-size-4">Acesse o histórico de calibração dos seus instrumentos.</p>
                    </div>
                  </div>
                  <div class="column">
                      <figure class="">
                          <img class="" src="../assets/img/thumb_tablet_full.png" alt="" style=""/>
                      </figure>
                  </div>
                </div>
            </div>
        </section>


        <section class="bg-white">
            <div class="container section">
                <div class="columns is-vcentered">
                    <div class="column ">
                      <div class="content">
                        <p class="landing-el title is-3">Visualização de certificados</p>
                        <p class="landing-el subtitle has-text-grey is-size-4">Visualize os certificados de calibração dos seus instrumentos em formato PDF, atuais e anteriores.</p>
                      </div>

                    </div>
                    <div class="column">
                        <figure class="">
                            <img class="" src="../assets/img/thumb_certificado_full.png" alt="" style="-webkit-mask-image: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgb(0, 0, 0)), color-stop(0.9, rgb(0, 0, 0)), color-stop(0.95, rgba(0, 0, 0, 0)), color-stop(1, rgba(0, 0, 0, 0)));}"/>
                        </figure>
                    </div>
                </div>
            </div>
        </section>


        <section class="bg-white">
            <div class="container section">
                <div class="columns is-vcentered">
                  <div class="column ">
                    <div class="content">
                      <p class="landing-el title is-3">Histórico de ocorrências</p>
                      <p class="landing-el subtitle has-text-grey is-size-4">Acesse o registro de mudanças feitas pelos usuários da plataforma.</p>
                    </div>

                  </div>
                  <div class="column">
                      <figure class="">
                          <img class="" src="../assets/img/thumb_ocorrencias_full.png" alt="" style=""/>
                      </figure>
                  </div>
                </div>
            </div>
        </section>


        <section class="bg-white">
            <div class="container section">
                <div class="columns is-vcentered">
                  <div class="column is-6">
                    <div class="content">
                      <p class="landing-el title is-3">Orçamento em poucos cliques</p>
                      <p class="landing-el subtitle has-text-grey is-size-4">A plataforma exibe a situação do instrumento usando esquemas de cores. Peça orçamentos facilmente.</p>
                    </div>
                  </div>
                  <div class="column is-2">
                  </div>
                  <div class="column is-4">
                      <figure class="">
                          <img class="" src="../assets/img/thumb_orcamento_full.png" alt="" style=""/>
                      </figure>
                  </div>
                </div>
            </div>
        </section>

        <section class="landing-el bg-light">
        <img class="rotate-180" src="../assets/img/section_wave.png" alt="" style="width: 100%;height: 40px;"/>
            <div class="container section">
                <div class="columns is-vcentered">
                  <div class="column">
                      <figure class="">
                          <img src="../assets/img/phone.png" alt="" style=""/>
                      </figure>
                  </div>
                  <div class="column ">
                    <div class="content">
                      <p ref="landingSaibaMais" class="landing-el title is-3">Descubra mais sobre a plataforma</p>
                      <p class="landing-el subtitle has-text-grey is-size-4">Para saber mais sobre a plataforma e como começar a usar, entre em contato pelo e-mail: <strong>procal@ipt.br</strong>.</p>
                    </div>
                  </div>
                </div>
            </div>
        </section>

        
        <section class="bg-white">
            <div class="container section">
                <div class="content has-text-centered">
                    <h1>Perguntas Frequentes</h1>
                </div>

                <div class="columns">
                    <div class="column is-half">
                        <div class="title is-5">Qual o custo para utilizar a plataforma?</div>
                        <p>A plataforma ProCal é oferecida sem custos para os clientes do Laboratório de Metrologia Elétrica do IPT (LME).</p>
                    </div>

                    <div class="column is-half">
                        <div class="title is-5">Posso inserir os dados dos meus instrumentos que não são calibrados no LME?</div>
                        <p>Sim. Possuímos ferramentas que facilitam a integração de planilhas com a plataforma. Podemos também desenvolver ferramentas para atender necessidades mais específicas e oferecer treinamento.</p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-half">
                      <div class="title is-5">Utilizo um método para análise de certificado que não está disponível. É possível implementá-lo na plataforma?</div>
                      <p>Cada usuário da plataforma pode ter sua metodologia própria para analisar os resultados das calibrações. Consulte-nos para a realização destas customizações que estarão disponíveis exclusivamente para sua equipe.</p>
                    </div>

                    <div class="column is-half">
                      <div class="title is-5">Meu instrumento retornou da calibração com o QR Code, mas não sei qual é o meu login.</div>
                      <p>Entre em contato através do e-mail procal@ipt.br. Você vai receber um e-mail com um link para definir suas informações de acesso.</p>
                    </div>
                </div>

            </div>
        </section>
        


        <footer class="footer bg-light">
            <div class="container">
              <div class="content has-text-centered ">
                  <p class="has-text-grey">
                    IPT - Instituto de Pesquisas Tecnológicas do Estado de São Paulo - {{new Date().getFullYear()}}
                  </p>
                  <p class="has-text-grey">
                    Laboratório de Metrologia Elétrica - F +55 11 3767-4948
                  </p>
                  
                  <p class="has-text-grey">
                    <a @click="instrumentState.modals.privacidade = true">Politica de privacidade</a> &nbsp;
                  </p>



              </div>
            </div>
        </footer>
    </div>
    
  </div>

</template>

<script>
  
export default {
  name: 'landing',
  watch: {
    'instrumentState.landingScroll': function(id) {
      //landingOQueE, landingFuncionalidades landingSaibaMais
      var elem = this.$refs[id]
      if (!elem) return
      var rect = elem.getBoundingClientRect()
      var win = elem.ownerDocument.defaultView

      var offset2 = -10
      if (id === 'landingSaibaMais' && typeof window.orientation === 'undefined') {
        offset2 = -420
      }

      window.scrollTo({
        top: rect.top + win.pageYOffset + offset2,
        left: 0,
        behavior: 'smooth'
      });
      this.instrumentState.landingScroll = null
      
    }
  },
  data () {
    return {
      instrumentState: INSTRUMENT_STORE.state
    }
  },
  methods: {
  },
  mounted () {
    
  },
  computed: {
  }

}
</script>

<style scoped>
</style>
